import LocalizationInterface from './LocalizationInterface';
import { LocalizationInterfaceType } from '@clientos/types';
import { getServices } from '../../../infra/startup';
import { Direction } from '../../../services/localizationService/constants';
import { ServiceLocalizationLanguageType } from '../../../services/localizationService/types';
import { internalLogger } from '../clientOsLogger';

let localizationInterface: LocalizationInterface;

export function getLocalizationInterface(): LocalizationInterface {
  return localizationInterface;
}

export default async function initializeLocalizationInterface(): Promise<LocalizationInterfaceType> {
  if (localizationInterface) return localizationInterface.getInterface();

  const { localizationService, localizationTranslatorService } = getServices();

  localizationInterface = new LocalizationInterface({
    localizationService,
    localizationTranslatorService
  });

  return localizationInterface.getInterface();
}

export function createNoopLocalizationInterface(): LocalizationInterfaceType {
  return {
    enabled: false,
    locale: '',
    language: '',
    country: '',
    getLanguages: function (): Promise<ServiceLocalizationLanguageType> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopLocalizationInterface',
        methodName: 'getLanguages()',
        message: 'Noop interface method called - returning empty object'
      });
      return Promise.resolve({});
    },
    getGlobalTranslatorFunction: function (): Promise<any> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopLocalizationInterface',
        methodName: 'getGlobalTranslatorFunction()',
        message: 'Noop interface method called - returning empty object'
      });
      return Promise.resolve({});
    },
    setLocale: function (): Promise<void> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopLocalizationInterface',
        methodName: 'setLocale()',
        message: 'Noop interface method called - returning resolved promise'
      });
      return Promise.resolve();
    },
    createTranslatorFunction: function (): Promise<any> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopLocalizationInterface',
        methodName: 'createTranslatorFunction()',
        message: 'Noop interface method called - returning empty string'
      });
      return Promise.resolve('');
    },
    getReactTranslatorProvider: function (): () => any {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopLocalizationInterface',
        methodName: 'getReactTranslatorProvider()',
        message: 'Noop interface method called - returning empty function'
      });
      return () => {};
    },
    useReactTranslatorHook: function () {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopLocalizationInterface',
        methodName: 'useReactTranslatorHook()',
        message: 'Noop interface method called - no operation performed'
      });
    },
    setLocalePreference: function (): void {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopLocalizationInterface',
        methodName: 'setLocalePreference()',
        message: 'Noop interface method called - no operation performed'
      });
    },
    getLocalePreference: function (): string {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopLocalizationInterface',
        methodName: 'getLocalePreference()',
        message: 'Noop interface method called - returning empty string'
      });
      return '';
    },
    getLanguageDirection: function (): Promise<Direction> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopLocalizationInterface',
        methodName: 'getLanguageDirection()',
        message: 'Noop interface method called - returning auto direction'
      });
      return Promise.resolve(Direction.auto);
    },
    prefetchLocaleFile: function (): Promise<any> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopLocalizationInterface',
        methodName: 'prefetchLocaleFile()',
        message: 'Noop interface method called - returning empty object'
      });
      return Promise.resolve({});
    },
    useReactGetLanguageDirection: function (): Direction {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopLocalizationInterface',
        methodName: 'useReactGetLanguageDirection()',
        message: 'Noop interface method called - returning rtl direction'
      });
      return Direction.rtl;
    }
  };
}
